import AppTheme from 'docs/src/modules/components/AppTheme';
import Home from 'docs/src/pages/premium-themes/onepirate/Home';

export default function Page() {
  return (
    <AppTheme title="Onepirate theme - MUI" description="A onepirate theme">
      <Home />
    </AppTheme>
  );
}
